import React from 'react';
import type {ResponsiveValue, TableCellProps} from '@tempo/core';
import {Th as TempoTh} from '@tempo/core';
import {useTableCellDisplayValue} from '../utils';
import {useTableContext} from '@components/Table';
import {useTableStyles} from '../contexts/TableStyleContext';

export type ThProps = {
	display?: ResponsiveValue<boolean>;
	colSpan?: number | 'full';
	sticky?: boolean;
} & Omit<TableCellProps, 'display' | 'colSpan'>;

const Th = ({display, colSpan, sticky, sx, ...props}: ThProps) => {
	const {columnCount} = useTableContext();
	const recipe = useTableStyles();
	const displayValue = useTableCellDisplayValue(display);

	return (
		<TempoTh
			{...props}
			display={displayValue}
			colSpan={colSpan === 'full' ? columnCount : colSpan}
			sx={{
				...recipe.th,
				...(sticky
					? {
							position: 'sticky',
							left: 0,
							backgroundColor: 'background.neutral.primary.default',
							zIndex: 'docked',
						}
					: {}),
				...sx,
			}}
		/>
	);
};

export default Th;
